module.exports = __webpack_public_path__ + "static/media/C_F01.ab9818fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/C_F01.png
// module id = 124
// module chunks = 0